import { makeStyles } from '@material-ui/core';

export const useWrapperStyles = makeStyles((theme) => ({
  root: {
    padding: '20px 40px',
    backgroundColor: '#ffffff',
    '& .print': {
      marginBottom: '20px',
    },
    [theme.breakpoints.down('xs')]: {
      padding: '20px',
    },
  },
  mainDetails: {
    display: 'flex',
    marginBottom: '30px',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
    '& > div:first-child': {
      paddingRight: '50px',
      [theme.breakpoints.down('sm')]: {
        marginBottom: '30px',
        paddingRight: '0',
        textAlign: 'center',
      },
    },
    '& > div:last-child': {
      flex: 1,
    },
    '& .row': {
      display: 'flex',
      '& > div': {
        width: '50%',
      },
      [theme.breakpoints.down('xs')]: {
        flexDirection: 'column',
        '& > div': {
          width: '100%',
        },
      },
    },
  },
  expiredText: {
    display: 'block',
    marginTop: '-10px',
    textAlign: 'center',
    fontSize: '2em',
    fontWeight: 'bolder',
    color: '#f00',
    overflow: 'hidden',
  },
  tabs: {
    display: 'inline-block',
    margin: '0 auto 30px',
  },
  tabsContainer: {
    display: 'flex',
  },
  topActions: {
    display: 'flex',
    flexWrap: 'wrap',
    marginBottom: '30px',
    '& > *': {
      marginRight: '10px',
      marginBottom: '10px',
    },
  },
}));

export const useDetailsStyles = makeStyles((theme) => ({
  root: {
    '& h1': {
      fontSize: '18px',
      margin: '0 0 0.6em',
    },
    '& p': {
      fontSize: '14px',
      margin: '0 0 0.3em',
      fontWeight: 'normal',
    },
    '& .active': {
      color: theme.custom.primary,
      fontWeight: '600',
    },
    '& .expires': {
      color: theme.custom.danger,
      fontWeight: '600',
    },
  },
}));

export const useRenewalStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: '30px',
    [theme.breakpoints.down('xs')]: {
      paddingLeft: '0',
      paddingTop: '20px',
    },
    '& img': {
      display: 'block',
      maxWidth: '120px',
      width: '100%',
      boxShadow: '0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)',
      marginBottom: '15px',
    },
    '& h5': {
      fontSize: '14px',
      fontWeight: '500',
      margin: '0 0 0.4em',
    },
  },
}));
